import { render, staticRenderFns } from "./datagrid.vue?vue&type=template&id=e46e57bc&scoped=true&"
import script from "./datagrid.vue?vue&type=script&lang=js&"
export * from "./datagrid.vue?vue&type=script&lang=js&"
import style0 from "./datagrid.vue?vue&type=style&index=0&id=e46e57bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46e57bc",
  null
  
)

export default component.exports